import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { HttpHandlingService } from 'src/app/api/services/http-handling.service';
import { UtilService } from 'src/app/api/services/util.service';
import { SERVER_API_URL } from 'src/app/common/types/app.constants';
import { EditSpeedTrialResult } from 'src/app/common/types/edit-speed-trial-result.interface';
import { SpeedTrialRequest } from 'src/app/common/types/speed-trial.model';
import { StageResult } from 'src/app/common/types/stage-result';

@Component({
  selector: 'app-edit-speed-trial-result',
  templateUrl: './edit-speed-trial-result.component.html',
  styleUrls: ['./edit-speed-trial-result.component.css']
})
export class EditSpeedTrialResultComponent implements AfterViewInit {

  speedTrialResultGroup = new UntypedFormGroup({
    minutes: new UntypedFormControl(null, Validators.required),
    seconds: new UntypedFormControl(null, Validators.required),
    milliseconds: new UntypedFormControl(null, Validators.required),
    points: new UntypedFormControl(null, Validators.required)
  });

  isOrganizer: boolean | null = false;
  speedTrialResult: SpeedTrialRequest | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: EditSpeedTrialResult, private dialogRef: MatDialogRef<EditSpeedTrialResultComponent>, 
              private httpHandlingService: HttpHandlingService, private http: HttpClient, private utilService: UtilService) { }
   
  ngAfterViewInit(): void {
    this.utilService.isLoggedCompetitorAnOrganizer(this.data.competitionId).subscribe((result: boolean) => {
      if (result) {
        this.isOrganizer = result;
      }
      this.getSpeedTrialById().subscribe((speedTrialResult: SpeedTrialRequest) => {
        this.speedTrialResult = speedTrialResult;
        this.speedTrialResultGroup.setValue({
          minutes: speedTrialResult.minutes,
          seconds: speedTrialResult.seconds,
          milliseconds: speedTrialResult.milliseconds,
          points: speedTrialResult.points
        });
      });
    });
  }

  /**
   * function for getting speed trial
   */
  getSpeedTrialById(): Observable<SpeedTrialRequest> {
    const speedTrialResultURL = SERVER_API_URL + '/api/speed-trial-detail/' + this.data.id;
    return this.http.get<SpeedTrialRequest>(speedTrialResultURL, { headers: this.httpHandlingService.authorizationHeaders() });
  }

  /**
   * function for updating speed trial
   */
  updateSpeedTrial(): void {
    if (this.speedTrialResult != null) {
      const request = new SpeedTrialRequest(this.speedTrialResult.id, this.speedTrialResult.crewNumber, this.speedTrialResultGroup.get('minutes').value, 
      this.speedTrialResultGroup.get('seconds').value, this.speedTrialResultGroup.get('milliseconds').value, this.speedTrialResultGroup.get('points').value, this.speedTrialResult.stageResultId);
      this.http.put<StageResult[]>(SERVER_API_URL + '/api/speed-trial-results', request,
        {headers: this.httpHandlingService.authorizationHeaders()}).subscribe((stageResults: StageResult[]) => {
          this.dialogRef.close(stageResults);
        });
    }
  }
}
